<mat-card class="ui-wrapper">
  <div class="row">
    <div class="col-md-6">
      <mat-card-title>{{ showDistributorColumns ? 'Distributors' : 'Companies' }}</mat-card-title>
    </div>
    <div class="col-md-6 text-end">
      <form [formGroup]="companyFilterForm">
        <mat-form-field appearance="outline" class="me-2">
          <mat-label>Search</mat-label>
          <input type="text" formControlName="search" matInput />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>company type</mat-label>
          <mat-select formControlName="companyType">
            <mat-option [value]="allCompanyTypes">All</mat-option>
            @for (type of companyTypes; track type) {
              <mat-option [value]="type.code">
                {{ type.type }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </div>
  </div>

  <mat-paginator
    [pageSizeOptions]="[10, 15, 20]"
    [pageIndex]="page - 1"
    [pageSize]="limit"
    [length]="totalNumberOfCompanies"
    showFirstLastButtons
    (page)="onPageChange($event)"
    aria-label="Select page of companies"
    >
  </mat-paginator>

  <div class="py-2">
    <mat-divider></mat-divider>
  </div>

  <table
    mat-table
    [dataSource]="companiesDataSource"
    matSort
    (matSortChange)="sortCompanies($event)"
    class="company-list"
    >
    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by Name"
        start="desc"
        >
        Name
      </th>
      <td mat-cell *matCellDef="let company">{{ company.name }}</td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let company">{{ getType(company) }}</td>
    </ng-container>

    @if (showDistributorColumns) {
      <ng-container matColumnDef="invoice_mode">
        <th mat-header-cell *matHeaderCellDef>Invoice mode</th>
        <td mat-cell *matCellDef="let company">{{ rowInvoiceMode(company) }}</td>
      </ng-container>
    }

    @if (showDistributorColumns) {
      <ng-container matColumnDef="weekly_invoice_day">
        <th mat-header-cell *matHeaderCellDef>Weekly day</th>
        <td mat-cell *matCellDef="let company">{{ rowWeeklyDay(company) }}</td>
      </ng-container>
    }

    @if (showDistributorColumns) {
      <ng-container matColumnDef="is_active">
        <th mat-header-cell *matHeaderCellDef>Active</th>
        <td mat-cell *matCellDef="let company">{{ rowActive(company) }}</td>
      </ng-container>
    }

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let company">
        {{ company.email ? company.email : "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="phone_number">
      <th mat-header-cell *matHeaderCellDef>Phone number</th>
      <td mat-cell *matCellDef="let company">
        {{ company.phone_number ? company.phone_number : "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="sage">
      <th mat-header-cell *matHeaderCellDef>Sage</th>
      <td mat-cell *matCellDef="let company">
        @if (isOnSage(company)) {
          <span class="text-success">On Sage</span>
        }
        @if (!isOnSage(company)) {
          <span class="text-muted">Not on Sage</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell *matCellDef="let company">
        {{ formatTime(company.created_at) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="updated_at">
      <th mat-header-cell *matHeaderCellDef>Updated</th>
      <td mat-cell *matCellDef="let company">
        {{ formatTime(company.updated_at) }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr
      mat-row
      (click)="openCompany(row)"
      *matRowDef="let row; columns: tableColumns"
    ></tr>
  </table>
</mat-card>